<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Type of Financials</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body ey-privacy-notice-body">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <p class="header">Selecting Any Available:</p>
        <div class="body">
          <p>
            If the any available option is selected, an additional selection of 'unconsolidated data preferred' or 'consolidated data preferred' is
            required. If only one type of financials is available, it will be used in calculating the IQR, displaying the financial review detail, the
            PLI summary report and the export financial data for exports, regardless the type of account.
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <p class="header">Additional options Any Available:</p>
        <div class="body">
          <ul>
            <li>
              Selecting Unconsolidated data preferred - If this option is selected and both types of financials are available, then only
              unconsolidated data will be used for calculations and financial details.
            </li>
            <li>
              Selecting Consolidated data preferred - If this option is selected and both types of financials are available, then only consolidated
              data will be used for calculations and financial details.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <p class="header">Selecting Unconsolidated data:</p>
        <div class="body">
          <p>
            If the unconsolidated data option is selected, then unconsolidated data will be used to calculate the IQR, display financial review
            details, the PLI summary report and the export financial data for exports. This also impacts what filters will be available in the account
            type filter. Only U1 and U2 options would be displayed plus the remaining limited financial options. If you want to search for companies
            reporting unconsolidated data only (U1), please apply additional account type filter in the search strategy.
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <p class="header">Selecting Consolidated data:</p>
        <div class="body">
          <p>
            If the consolidated data option is selected, then consolidated data will be used to calculate the IQR, display financial review details,
            the PLI summary report and the export financial data for exports. This also impacts what filters will be available in the account type
            filter. Only C1 and C2 options would be displayed plus the remaining limited financial options. If you want to search for companies
            reporting consolidated data only (C1), please apply additional account type filter in the search strategy.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="close()">Close</button>
</div>
